<template>
    <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>
        <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
        <loadingcomp v-bind:mesaj="loadingmesaj" v-model="loadingvmodel"></loadingcomp>

        <!-- toolbar -->
        <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{ $t("Hotel-Reservation-List") }}</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-flex xs12 sm3 md3>
                    <v-text-field flat="" prepend-inner-icon="live_help" v-model="Rapor.Filtreler.SearchText"
                        solo-inverted="" hide-details :label="$t('Search')" @click:append="getListPageZero()"
                        append-icon="search" @keyup.enter="getListPageZero()">
                    </v-text-field>
                </v-flex>
            </v-toolbar>
        </v-flex>

        <!-- form input -->
        <v-flex xs12 sm12 md12>
            <v-form ref="formFilters" lazy-validation>
                <v-card flat class="pa-3">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                                <!-- Kayıt Tarihi Başlangıcı -->
                                <v-flex xs12 sm6 md2>
                                    <tarihim :etiket="$t('Starting-Date')" v-model="Rapor.Filtreler.KayitTarihiBasla"
                                        :detaygizle="false" :rules="[(v) => !!v || $t('Please-select-a-date')]"
                                        v-bind:defaultvalue="'ok'"></tarihim>
                                </v-flex>

                                <!-- Kayıt Tarihi Bitişi -->
                                <v-flex xs12 sm6 md2>
                                    <tarihim :etiket="$t('Finishing-Date')" v-model="Rapor.Filtreler.KayitTarihiBitis"
                                        :detaygizle="false" :rules="[(v) => !!v || $t('Please-select-a-date')]"
                                        v-bind:defaultvalue="'ok'"></tarihim>
                                </v-flex>

                                <!-- Check-in Tarihi -->
                                <v-flex xs12 sm6 md2>
                                    <tarihim :etiket="$t('Check-In')" v-model="Rapor.Filtreler.Prm.PDonem1Bas"
                                        :detaygizle="false"></tarihim>
                                </v-flex>

                                <!-- Check-out Tarihi -->
                                <v-flex xs12 sm6 md2>
                                    <tarihim :etiket="$t('Check-Out')" v-model="Rapor.Filtreler.Prm.PDonem2Bit"
                                        :detaygizle="false"></tarihim>
                                </v-flex>
                                <v-flex xs12 sm4 md4>
                                    <v-text-field :label="$t('Counter-Booking-Code')"
                                        v-model="Rapor.Filtreler.Prm.PRezzKod">

                                    </v-text-field>
                                </v-flex>
                                <!-- Para Birimi -->
                                <v-flex xs12 sm6 md2>
                                    <v-select hide-details v-model="Rapor.Filtreler.ParaBirimi" :items="dovizItems"
                                        :rules="[(v) => !!v || $t('Mandatory-section')]" item-text="Title"
                                        item-value="DovizKod" :label="$t('Currency-Unit')"></v-select>
                                </v-flex>

                                <!-- Arama Buttons -->
                                <v-flex xs12 sm6 md2>
                                    <v-layout>
                                        <v-btn color="info" @click="getList()" fab small dark>
                                            <v-icon>search</v-icon>
                                        </v-btn>
                                        <v-badge color="white" :overlap="true">
                                            <template v-slot:badge>
                                                <v-icon v-if="filtrevarmi" large
                                                    color="green">check_circle_outline</v-icon>
                                            </template>
                                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false"
                                                ref="fab" @click="filtreOpen()" color="info" fab dark>
                                                <v-icon>filter_list</v-icon>
                                            </v-btn>
                                        </v-badge>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-form>
        </v-flex>

        <!-- Sıralama ve Sayfa Seçimi -->
        <v-flex xs12 sm12 md12 pl-3 pr-3>
            <v-card width="100%" flat color="grey lighten-5">
                <v-layout row wrap align-center>
                    <v-flex xs12 sm12 md9 class="headline font-weight-regular pl-3 grey--text">
                        {{ totalCountText }}
                    </v-flex>
                    <v-flex xs12 sm12 md2 pt-2>
                        <v-select :label="$t('Sort-By')" :items="siralamaItems" item-text="Text" item-value="Value"
                            v-model="Rapor.Paging.SiralamaTip" @change="getListPageZero()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md1 pt-2>
                        <v-select :label="$t('Show')" :items="veriItem" item-text="Text" item-value="Value"
                            v-model="Rapor.Paging.VeriAdet" @change="getListPageZero()"></v-select>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

        <!-- listeleme -->
        <v-container fluid grid-list-sm>
            <v-flex v-for="item in cardItems" v-bind:key="item.SiraNo" pb-3 xs12 sm12 md12>
                <v-hover>
                    <v-card width="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                        class="elevation-1 pt-3 pl-3 pb-3">
                        <v-layout row wrap align-center justify-end>
                            <!-- PNR ve Detaylar -->
                            <v-flex xs12 sm6 md3>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <v-icon color="info" small>confirmation_number</v-icon>
                                        {{ item.PNR_No }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <v-icon color="info" small>confirmation_number</v-icon>
                                        {{ item.RezzKod }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <v-icon color="#67768f" small>supervisor_account</v-icon>
                                        {{ item.Isim }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-bold grey--text caption">
                                        <v-icon color="#67768f" small>payment</v-icon>
                                        {{ item.CariKod }} / {{ item.Unvan }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <!-- Tarihler -->
                            <v-flex xs12 sm6 md2>
                                <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                    <span style="color: #67768f">{{ $t('Record') }}:</span>
                                    {{ item.KayitTarihi | dateformat }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                    <span style="color: #67768f">{{ $t('Check-In') }}:</span>
                                    {{ item.IlkGiris | dateformat }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                    <span style="color: #67768f">{{ $t('Check-Out') }}:</span>
                                    {{ item.SonCikis | dateformat }}
                                </v-flex>
                            </v-flex>

                            <!-- Otel ve Tur Operatörü -->
                            <v-flex xs12 sm6 md2>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12 class="font-weight-large grey--text caption">
                                        <v-icon color="info" small>hotel</v-icon>
                                        {{ item.SaticiAd }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <span style="color: #67768f">{{ $t('Tour-Operator') }}:</span>
                                        {{ item.TurOperator || '-' }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <!-- Finansal Bilgiler -->
                            <v-flex xs12 sm6 md2>
                                <v-flex xs12 sm12 md12 class="font-weight-large grey--text caption">
                                    <span style="color: #67768f">{{ $t('Purchase-Total') }}:</span>
                                    {{ item.Alis | moneyformat }} {{ selectedCurrency }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="font-weight-large grey--text caption">
                                    <span style="color: #67768f">{{ $t('Received-Coms.-Total') }}:</span>
                                    {{ item.Komisyon | moneyformat }} {{ selectedCurrency }}
                                </v-flex>
                            </v-flex>

                            <!-- Satış Toplamı -->
                            <v-flex xs12 sm6 md2>
                                <v-flex xs12 sm12 md12 style="color: #67768f"
                                    class="font-weight-regular headline text-md-center">
                                    {{ item.Satis | moneyformat }} {{ selectedCurrency }}
                                </v-flex>
                            </v-flex>

                            <!-- İşlemler -->
                            <v-flex xs12 sm6 md1>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-tooltip bottom>
                                            <v-btn icon medium slot="activator" flat @click="git(item)">
                                                <v-icon color="info" medium>search</v-icon>
                                            </v-btn>
                                            <span>{{ $t('Detail') }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-tooltip bottom>
                                            <v-btn icon medium slot="activator" flat
                                                   :loading="voucherLoadingRowKey === item.SiraNo"
                                                   :disabled="voucherLoadingRowKey !== null"
                                                   @click="voucherPdfAc(item)">
                                                <v-icon color="error" medium>picture_as_pdf</v-icon>
                                            </v-btn>
                                            <span>{{ $t('Voucher-PDF') }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-tooltip bottom>
                                            <v-btn icon medium slot="activator" flat
                                                   :loading="iptalLoadingRowKey === item.SiraNo"
                                                   :disabled="iptalLoadingRowKey !== null || !sessionHeader.SessionId"
                                                   @click="iptalOnayAc(item)">
                                                <v-icon color="error" medium>event_busy</v-icon>
                                            </v-btn>
                                            <span>{{ $t('Cancel-Reservation') }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-hover>
            </v-flex>
        </v-container>

        <!-- sayfalama -->
        <template v-if="vmodelpagination">
            <div class="text-xs-center">
                <v-container>
                    <v-layout justify-center>
                        <v-flex xs8>
                            <v-pagination :disabled="paginationDisabled" color="info" v-model="sayfalama"
                                :length="pagenumber"></v-pagination>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </template>

        <!-- Filtre Dialog -->
        <v-dialog v-model="filtreDialogStatus" scrollable persistent max-width="600px">
            <v-card flat color="grey lighten-4">
                <v-card-title>{{ $t('Filter-Selection') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 pa-2>
                            <!-- PNR -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <pnrbul v-model="Rapor.Filtreler.Prm.PPNR_No" :label="$t('PNR-No')" hide-details>
                                </pnrbul>
                            </v-flex>

                            <!-- Cari Kod -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <cariaracomp v-bind:etiket="$t('Currentcode_label')"
                                    v-bind:value="Rapor.Filtreler.Prm.PCariKod" v-model="Rapor.Filtreler.Prm.PCariKod"
                                    :Coper="false"></cariaracomp>
                            </v-flex>
                            <!-- Otel -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <genelarama apiname="SaticiAra" :tip="1" :label="$t('Hotel')"
                                    v-model="Rapor.Filtreler.Prm.PSaticiKod"></genelarama>
                            </v-flex>
                            <!-- Tur Operatörü -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <genelarama apiname="SaticiAra" :tip="12" :label="$t('Tour-Operator')"
                                    v-model="Rapor.Filtreler.Prm.PTurOp"></genelarama>
                            </v-flex>

                            <!-- Check-in Tarihi Başlangıcı -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Check-In') + ' ' + $t('Starting-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem1Bas" :detaygizle="false"></tarihim>
                            </v-flex>

                            <!-- Check-in Tarihi Bitişi -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Check-In') + ' ' + $t('Finishing-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem1Bit" :detaygizle="false"></tarihim>
                            </v-flex>

                            <!-- Check-out Tarihi Başlangıcı -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Check-Out') + ' ' + $t('Starting-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem2Bas" :detaygizle="false"></tarihim>
                            </v-flex>

                            <!-- Check-out Tarihi Bitişi -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Check-Out') + ' ' + $t('Finishing-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem2Bit" :detaygizle="false"></tarihim>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="filtreiptal()">
                        {{ $t("cancel_button") }}
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click="filtrekayit()">
                        {{ $t('Apply-Filters') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Senkronize Dialog -->
        <v-dialog v-model="senkronizeDialogStatus" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
                <v-card-title>{{ $t('Hotel-Provider-Reservation-Sync') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 pa-2>
                            <!-- Tarih Tipi Seçimi -->
                            <v-flex xs12 sm12 md12 pb-3>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                        <span class="font-weight-medium">{{ $t('Hotel-Date-Type-Select') }}</span>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-btn-toggle v-model="senkronizeForm.tarihTipi" mandatory>
                                            <v-btn value="kayit" small>{{ $t('Hotel-Record-Date') }}</v-btn>
                                            <v-btn value="checkin" small>{{ $t('Hotel-Check-In-Date-Toggle') }}</v-btn>
                                        </v-btn-toggle>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <!-- Kayıt Tarihi Alanları -->
                            <v-flex xs12 sm12 md12 pb-2 v-if="senkronizeForm.tarihTipi === 'kayit'">
                                <tarihim :etiket="$t('Starting-Date')" v-model="senkronizeForm.From"
                                    :detaygizle="false"></tarihim>
                            </v-flex>
                            <v-flex xs12 sm12 md12 pb-2 v-if="senkronizeForm.tarihTipi === 'kayit'">
                                <tarihim :etiket="$t('Finishing-Date')" v-model="senkronizeForm.To"
                                    :detaygizle="false"></tarihim>
                            </v-flex>

                            <!-- Check-In Tarihi Alanları -->
                            <v-flex xs12 sm12 md12 pb-2 v-if="senkronizeForm.tarihTipi === 'checkin'">
                                <tarihim :etiket="$t('Check-In') + ' ' + $t('Starting-Date')"
                                    v-model="senkronizeForm.CheckInFrom" :detaygizle="false"></tarihim>
                            </v-flex>
                            <v-flex xs12 sm12 md12 pb-2 v-if="senkronizeForm.tarihTipi === 'checkin'">
                                <tarihim :etiket="$t('Check-In') + ' ' + $t('Finishing-Date')"
                                    v-model="senkronizeForm.CheckInTo" :detaygizle="false"></tarihim>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="caption grey--text">
                                {{ $t('Hotel-Date-Range-Note') }}
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="senkronizeDialogIptal()">
                        {{ $t("cancel_button") }}
                    </v-btn>
                    <v-btn color="success" flat @click="senkronizeEt()">
                        {{ $t('Hotel-Fetch-Button') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Rezervasyon İptal Dialog -->
        <v-dialog v-model="iptalDialogStatus" scrollable persistent max-width="600px">
            <v-card flat color="grey lighten-4">
                <v-card-title>{{ $t('Cancel-Reservation-v2') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout row wrap v-if="iptalPenaltyResponse">
                        <v-flex xs12 sm12 md12 pb-2 v-if="!iptalCanConfirmCancel">
                            <v-alert :value="true" type="warning">
                                {{ $t('Reservation-Not-Cancelable') }}
                            </v-alert>
                        </v-flex>

                        <v-flex xs12 sm12 md12 pb-3
                                v-for="(penalty, idx) in iptalPenaltyResponse.body.cancelPenalties"
                                v-bind:key="idx">
                            <v-card flat outline class="pa-2">
                                <v-flex xs12 sm12 md12 class="font-weight-medium">
                                    {{ penalty.reason.name }}
                                    <span class="grey--text caption" v-if="penalty.reason.comment">
                                        — {{ penalty.reason.comment }}
                                    </span>
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="caption pl-2"
                                        v-for="(service, sIdx) in penalty.services" v-bind:key="sIdx">
                                    {{ service.name }} — {{ $t('Penalty-Amount') }}:
                                    {{ service.priceDetail.penalty.amount | moneyformat }}
                                    {{ service.priceDetail.penalty.currency }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="font-weight-bold text-md-right">
                                    {{ $t('Amount-Without-Penalty') }}:
                                    {{ penalty.price.amount | moneyformat }} {{ penalty.price.currency }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 v-if="!penalty.isCancelable" class="error--text caption">
                                    {{ $t('Not-Cancelable-Item') }}
                                </v-flex>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 sm12 md12 pt-3>
                            <v-select :label="$t('Cancellation-Reason')"
                                      v-model="iptalSelectedReason"
                                      :items="iptalReasonOptions"
                                      item-text="name"
                                      item-value="id"
                                      required>
                                <template slot="item" slot-scope="{ item }">
                                    <div>
                                        <div class="font-weight-medium">{{ item.name }}</div>
                                        <div class="caption grey--text" v-if="item.comment">{{ item.comment }}</div>
                                    </div>
                                </template>
                                <template slot="selection" slot-scope="{ item }">
                                    {{ item.name }}
                                </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-else>
                        <v-flex xs12 sm12 md12 class="text-xs-center pa-3">
                            {{ $t('Loading') }}
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="iptalDialogIptal()">
                        {{ $t('cancel_button') }}
                    </v-btn>
                    <v-btn color="error" flat
                           :loading="iptalConfirmLoading"
                           :disabled="!iptalCanConfirmCancel"
                           @click="rezervasyonIptalEt()">
                        {{ $t('Cancel-Reservation-v2') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import tarihim from "@/components/app/customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "../../../../api/auth";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import hotelSearchService from "./hotelSearchService";

export default {
    data() {
        return {
            filtreDialogStatus: false,
            senkronizeDialogStatus: false,
            loadingmesaj: "",
            loadingvmodel: false,
            selectedCurrency: null,
            dovizItems: [],
            cardItems: [],
            totalCountText: null,
            paginationDisabled: false,
            vmodelpagination: false,
            sayfalama: 1,
            pagenumber: 1,
            text1: "",
            snackbar: false,
            filtrevarmi: false,
            tooltip: false,
            el: null,
            senkronizeForm: {
                tarihTipi: 'kayit',
                From: null,
                To: null,
                CheckInFrom: null,
                CheckInTo: null,
            },
            iptalDialogStatus: false,
            iptalSelectedItem: null,
            iptalPenaltyResponse: null,
            iptalSelectedReason: null,
            iptalLoadingRowKey: null,
            iptalConfirmLoading: false,
            voucherLoadingRowKey: null,
            providerBookings: [],
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0
            },
            dictionary: {
                custom: {
                    tarihsec: {
                        required: () => this.$t('Please-choose-a-date')
                    },
                    tarihsec1: {
                        required: () => this.$t('Please-choose-a-date')
                    }
                }
            },
            veriItem: [
                { Text: "25", Value: 25 },
                { Text: "50", Value: 50 },
                { Text: "100", Value: 100 },
            ],
            siralamaItems: [
                { Text: this.$t('PNR-Number-Ascending'), Value: 0 },
                { Text: this.$t('PNR-Number-Descending'), Value: 1 },
                { Text: this.$t('Record-Date-Ascending'), Value: 2 },
                { Text: this.$t('Record-Date-Descending'), Value: 3 },
                { Text: this.$t('Check-In-Date-Ascending'), Value: 6 },
                { Text: this.$t('Check-In-Date-Descending'), Value: 7 },
            ],
            firmaBilgileri: null,
            bookingUsername: '',
            bookingPassword: '',
            sessionHeader: { SessionId: null, SessionToken: null },
            itemsproviders: [],
            Rapor: {
                Filtreler: {
                    KayitTarihiBasla: null,
                    KayitTarihiBitis: null,
                    ParaBirimi: "TL",
                    SearchText: null,
                    Prm: {
                        PCariKod: null,
                        PPNR_No: null,
                        PSirketNo: null,
                        PCariSirket: null,
                        PPNR_ParaBirimi: null,
                        PKayitTarihBas: null,
                        PKayitTarihBit: null,
                        PDonem1Bas: null,
                        PDonem1Bit: null,
                        PDonem2Bas: null,
                        PDonem2Bit: null,
                        PFatTarihBas: null,
                        PFatTarihBit: null,
                        PKomFatTarihBas: null,
                        PKomFatTarihBit: null,
                        PSaticiTip: 1,
                        PSaticiKod: null,
                        PDosyaTip: null,
                        PDosya: null,
                        PAcente: null,
                        PPNRBir: null,
                        PCariHesapGrubu: null,
                        PCariTip: null,
                        PSaticiGrup: null,
                        PSaticiIc_Dis: null,
                        PTurOp: null,
                        PFaturali: null,
                        POpsiyon: null,
                        PAnaTip: null,
                        PCariAnaHesap: null,
                        PIptalRaporu: null,
                        PIptalDahil: true,
                        PRezGrupID: null,
                        PSatisGrubu: null,
                        PSatisGrupTip: null,
                        PSaticiOdemesiHesapla: null,
                        PMasrafMerkezi: null,
                        PAcenteDepartmanID: null,
                        PPozisyonNo: null,
                        PSatisFaturaNo: null,
                        PMusteriOdemelilerHaric: null,
                        PReferans: null,
                        PSatisTip1: null,
                        PSatisTip2: null,
                        PSatisTip3: null,
                        PSatisTip4: null,
                        PGelenFatTarihBas: null,
                        PGelenFatTarihBit: null,
                        PProfilSablonId: null,
                        PKomisyonFaturali: null,
                        PGelenFaturali: null,
                        PDonem1Bas: null,
                        PDonem1Bit: null,
                        PDonem2Bas: null,
                        PDonem2Bit: null,
                        PRezzKod: null
                    },
                },
                Paging: {
                    SiralamaTip: 0,
                    SayfaNo: 1,
                    VeriAdet: 25,
                },
            },
        };
    },
    components: {
        tarihim,
        pnrbul,
        cariaracomp,
        genelarama,
        snackbarcomp,
        yetkidialog,
        loadingcomp,
    },
    watch: {
        sayfalama() {
            this.getList();
        },
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },
    },
    computed: {
        iptalReasonOptions() {
            if (!this.iptalPenaltyResponse) return [];
            const penalties = this.iptalPenaltyResponse.body.cancelPenalties || [];
            const reasonMap = {};
            penalties.forEach(penalty => {
                if (penalty.reason && penalty.reason.id) {
                    reasonMap[penalty.reason.id] = {
                        id: penalty.reason.id,
                        name: penalty.reason.name,
                        comment: penalty.reason.comment
                    };
                }
            });
            return Object.values(reasonMap);
        },
        iptalCanConfirmCancel() {
            if (!this.iptalPenaltyResponse || this.iptalConfirmLoading) return false;
            if (!this.iptalSelectedReason) return false;
            const penalties = this.iptalPenaltyResponse.body.cancelPenalties || [];
            return penalties.length > 0 && penalties.every(p => p.isCancelable);
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prevRoute = from.path;
        });
    },
    mounted() {
        this.el = this.$refs.fab && this.$refs.fab.$el || null;
        this.$validator.localize("en", this.dictionary);
        this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
        this.BookingKontrol();
    },
    methods: {
        git(val) {
            let url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
            window.open(url, "_target");
        },
        voucherPdfAc(item) {
            this.voucherLoadingRowKey = item.SiraNo;
            var lang = this.$i18n.locale || 'tr';
            tool.downloadHotelVoucherPdf(this, item.PNR_No, lang)
                .then(() => {
                    this.voucherLoadingRowKey = null;
                })
                .catch((error) => {
                    this.text1 = this.$t('An-error-has-occurred-Please-try-again');
                    this.snackbar = true;
                    this.voucherLoadingRowKey = null;
                });
        },
        getList() {
            if (this.$refs.formFilters.validate()) {
                this.loadingvmodel = true;
                var _bastarih = new Date(this.Rapor.Filtreler.KayitTarihiBasla);
                var _bittarih = new Date(this.Rapor.Filtreler.KayitTarihiBitis);

                if (_bastarih <= _bittarih) {
                    var _credentials = JSON.parse(
                        window.localStorage.getItem("credentials")
                    );
                    if (this.Rapor.Filtreler.Prm.PSaticiKod != null) {
                        this.Rapor.Filtreler.Prm.PSaticiKod =
                            this.Rapor.Filtreler.Prm.PSaticiKod.kod;
                    }
                    this.Rapor.Paging.SiralamaTip = this.Rapor.Paging.SiralamaTip;
                    this.Rapor.Paging.SayfaNo = this.sayfalama;
                    this.Rapor.Paging.VeriAdet = this.Rapor.Paging.VeriAdet;

                    this.Rapor.Filtreler.Prm.PCariSirket = _credentials.SirketKodu;
                    this.Rapor.Filtreler.Prm.PSirketNo = _credentials.CoperSirketNo;

                    if (this.Rapor.Filtreler.Prm.PTurOp != null) {
                        this.Rapor.Filtreler.Prm.PTurOp =
                            this.Rapor.Filtreler.Prm.PTurOp.kod;
                    }

                    tool.http_post(this, "GunlukSatisListPagingOtel", this.Rapor).then(
                        (response) => {
                            if (response.body.Status == true) {
                                this.pagenumber = response.body.PageTotals.TotalPage;
                                if (response.body.PageTotals.TotalCount > 0) {
                                    this.totalCountText =
                                        this.$t("Total") +
                                        " " +
                                        response.body.PageTotals.TotalCount +
                                        " " +
                                        this.$t("Number-of-Records-Found");
                                } else {
                                    this.totalCountText = this.$t("No-Records-Found");
                                }

                                this.selectedCurrency = this.Rapor.Filtreler.ParaBirimi;
                                this.vmodelpagination = true;
                                this.cardItems = response.body.data;
                                this.loadingvmodel = false;
                            } else {
                                this.text1 = response.body.ErrorList[0];
                                this.snackbar = true;
                                this.loadingvmodel = false;
                            }
                        },
                        (response) => {
                            this.HataYonetimi(response, this.Rapor, "Otel Rezervasyonları Getirilemedi");
                            this.loadingvmodel = false;
                        }
                    );
                } else {
                    this.text1 = this.$t("start-date-cannot-greater-than-end-date");
                    this.snackbar = true;
                    this.loadingvmodel = false;
                }
            }
        },

        async BookingKontrol() {
            const firmaOk = await this.firmaBilgileriGetir();
            if (!firmaOk) return;

            const ekUrunOk = await this.ekUrunGetir();
            if (!ekUrunOk) return;

            const agencyExists = await this.chkAgency();
            if (!agencyExists) {
                const added = await this.addAgency();
                if (!added) return;
            }

            await this.login();
        },

        async firmaBilgileriGetir() {
            try {
                const credentials = JSON.parse(localStorage.getItem('credentials') || '{}');
                const resp = await this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet',
                    { SirketKodu: credentials.SirketKodu },
                    { headers: { Authorization: 'Bearer ' + auth.getAuthHeader() } });

                this.firmaBilgileri = {
                    Name: credentials.CoperSirketAdi,
                    City: resp.body.Il,
                    District: resp.body.Ilce,
                    Address: resp.body.Adres,
                    Gsm: resp.body.Tel,
                    Email: resp.body.Email,
                    TaxOffice: resp.body.VergiDairesi,
                    TaxNo: resp.body.VergiNo
                };

                if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
                    return false;
                }
                return true;
            } catch {
                return false;
            }
        },

        async ekUrunGetir() {
            try {
                const resp = await this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList',
                    { GrupID: null, UrunID: null, MusteriID: null },
                    { headers: { Authorization: 'Bearer ' + auth.getAuthHeader() } });
                const aktif = resp.body[3] && resp.body[3].Aktif;
                if (!aktif) {
                    return false;
                }
                return true;
            } catch {
                return false;
            }
        },

        async chkAgency() {
            try {
                const resp = await this.$http.post(auth.BOOKING_API_URL + 'Agency/CheckAgency',
                    { Email: this.firmaBilgileri.Email, TaxNo: this.firmaBilgileri.TaxNo },
                    { headers: { Authorization: 'Bearer ' + auth.getAuthHeader() } });
                if (resp.body.HasError) {
                    return false;
                }
                this.bookingUsername = resp.body.Username;
                this.bookingPassword = resp.body.Password;
                return true;
            } catch {
                return false;
            }
        },

        async addAgency() {
            try {
                const resp = await this.$http.post(auth.BOOKING_API_URL + 'Agency/AddAgency',
                    { ...this.firmaBilgileri, IsActive: true, CountryCode: 'TR' },
                    { headers: { Authorization: 'Bearer ' + auth.getAuthHeader() } });
                if (resp.body.Username) {
                    this.bookingUsername = resp.body.Username;
                    this.bookingPassword = resp.body.Password;
                }
                return true;
            } catch {
                return false;
            }
        },

        async login() {
            try {
                const resp = await this.$http.post(auth.BOOKING_API_URL + 'Login',
                    { Username: this.bookingUsername, Password: this.bookingPassword, IsTest: false },
                    { headers: { Authorization: 'Bearer ' + auth.getAuthHeader() } });
                this.sessionHeader = {
                    SessionId: resp.body.SessionId,
                    SessionToken: resp.body.SessionToken
                };
                localStorage.setItem('bookingParams', JSON.stringify(resp.body));
            } catch {
            }
        },

        HataYonetimi(response, request, baslik) {
            if (response.status === 500) {
                this.text1 = "Sunucu hatası - " + baslik;
                this.snackbar = true;
            } else {
                this.text1 = "Service Unavailable - " + baslik;
                this.snackbar = true;
            }
        },

        getListPageZero() {
            this.sayfalama = 1;
            this.getList();
        },

        filtreOpen() {
            this.filtreDialogStatus = true;
        },

        filtrekayit() {
            this.filtrevarmi = true;
            this.filtreDialogStatus = false;
            this.sayfalama = 1;
            this.getList();
        },

        filtreiptal() {
            this.filtrevarmi = false;
            this.filtreDialogStatus = false;
            this.Rapor.Filtreler.Prm.PPNR_No = null;
            this.Rapor.Filtreler.Prm.PCariKod = null;
            this.Rapor.Filtreler.Prm.PTurOp = null;
            this.Rapor.Filtreler.Prm.PSaticiTip = 1;
            this.Rapor.Filtreler.Prm.PSaticiKod = null;
            this.Rapor.Filtreler.Prm.PDosyaTip = null;
            this.Rapor.Filtreler.Prm.PDosya = null;
            this.Rapor.Filtreler.Prm.PAcente = null;
            this.Rapor.Filtreler.Prm.PPNRBir = null;
            this.Rapor.Filtreler.Prm.PCariHesapGrubu = null;
            this.Rapor.Filtreler.Prm.PCariTip = null;
            this.Rapor.Filtreler.Prm.PSaticiGrup = null;
            this.Rapor.Filtreler.Prm.PSaticiIc_Dis = null;
            this.Rapor.Filtreler.Prm.PFaturali = null;
            this.Rapor.Filtreler.Prm.POpsiyon = null;
            this.Rapor.Filtreler.Prm.PAnaTip = null;
            this.Rapor.Filtreler.Prm.PCariAnaHesap = null;
            this.Rapor.Filtreler.Prm.PIptalRaporu = null;
            this.Rapor.Filtreler.Prm.PRezGrupID = null;
            this.Rapor.Filtreler.Prm.PSatisGrubu = null;
            this.Rapor.Filtreler.Prm.PSatisGrupTip = null;
            this.Rapor.Filtreler.Prm.PSaticiOdemesiHesapla = null;
            this.Rapor.Filtreler.Prm.PMasrafMerkezi = null;
            this.Rapor.Filtreler.Prm.PAcenteDepartmanID = null;
            this.Rapor.Filtreler.Prm.PPozisyonNo = null;
            this.Rapor.Filtreler.Prm.PSatisFaturaNo = null;
            this.Rapor.Filtreler.Prm.PMusteriOdemelilerHaric = null;
            this.Rapor.Filtreler.Prm.PReferans = null;
            this.Rapor.Filtreler.Prm.PSatisTip1 = null;
            this.Rapor.Filtreler.Prm.PSatisTip2 = null;
            this.Rapor.Filtreler.Prm.PSatisTip3 = null;
            this.Rapor.Filtreler.Prm.PSatisTip4 = null;
            this.Rapor.Filtreler.Prm.PProfilSablonId = null;
            this.Rapor.Filtreler.Prm.PKomisyonFaturali = null;
            this.Rapor.Filtreler.Prm.PGelenFaturali = null;
            this.Rapor.Filtreler.Prm.PDonem1Bas = null;
            this.Rapor.Filtreler.Prm.PDonem1Bit = null;
            this.Rapor.Filtreler.Prm.PDonem2Bas = null;
            this.Rapor.Filtreler.Prm.PDonem2Bit = null;
        },

        senkronizeDialogAc() {
            this.senkronizeDialogStatus = true;
        },

        senkronizeDialogIptal() {
            this.senkronizeDialogStatus = false;
            this.senkronizeForm.From = null;
            this.senkronizeForm.To = null;
            this.senkronizeForm.CheckInFrom = null;
            this.senkronizeForm.CheckInTo = null;
            this.senkronizeForm.tarihTipi = 'kayit';
        },

        senkronizeEt() {
            const { tarihTipi, From, To, CheckInFrom, CheckInTo } = this.senkronizeForm;
            const bas = new Date(tarihTipi === 'kayit' ? From : CheckInFrom);
            const bit = new Date(tarihTipi === 'kayit' ? To : CheckInTo);
            const birAyMs = 31 * 24 * 60 * 60 * 1000;

            if (!bas || !bit || isNaN(bas) || isNaN(bit)) {
                this.text1 = this.$t('Please-select-a-date');
                this.snackbar = true;
                return;
            }

            if (bit < bas || (bit - bas) > birAyMs) {
                this.text1 = this.$t('Hotel-Date-Range-Validation');
                this.snackbar = true;
                return;
            }

            const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
            if (!bookingParams) {
                this.text1 = this.$t('Hotel-Provider-Session-Not-Found');
                this.snackbar = true;
                return;
            }

            this.loadingvmodel = true;
            const payload = {
                SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
                From: tarihTipi === 'kayit' ? From : null,
                To: tarihTipi === 'kayit' ? To : null,
                CheckInFrom: tarihTipi === 'checkin' ? CheckInFrom : null,
                CheckInTo: tarihTipi === 'checkin' ? CheckInTo : null,
                AllBookings: false,
            };

            hotelSearchService.getReservationList(this.$http, payload).then(
                (response) => {
                    this.loadingvmodel = false;
                    this.providerBookings = response.body.Bookings || [];
                    console.log('HotelReservationList response:', response.body);
                    this.senkronizeDialogStatus = false;
                    this.text1 = this.$t('Hotel-Fetch-Records-Success', {count: this.providerBookings.length});
                    this.snackbar = true;
                },
                (response) => {
                    this.loadingvmodel = false;
                    this.HataYonetimi(response, payload, this.$t('Hotel-Reservations-Fetch-Error'));
                }
            );
        },

        iptalOnayAc(item) {
            if (!item.ShoppingCardId) {
                this.text1 = this.$t('Missing-ShoppingCardId-Message');
                this.snackbar = true;
                return;
            }
            if (!this.sessionHeader || !this.sessionHeader.SessionId) {
                this.text1 = this.$t('Booking-Session-Not-Ready');
                this.snackbar = true;
                return;
            }

            this.iptalSelectedItem = item;
            this.iptalPenaltyResponse = null;
            this.iptalSelectedReason = null;
            this.iptalLoadingRowKey = item.SiraNo;
            this.iptalDialogStatus = true;

            const payload = {
                SessionHeader: this.sessionHeader,
                PNR_No: item.RezzKod,
                ShoppingCartId: item.ShoppingCardId,
            };

            hotelSearchService.getReservationCancelPenalty(this.$http, payload).then(
                (response) => {
                    this.iptalLoadingRowKey = null;
                    if (response.body.HasError) {
                        this.text1 = (response.body.ServiceError && response.body.ServiceError.Message) || this.$t('Cancel-Penalty-Fetch-Failed');
                        this.snackbar = true;
                        this.iptalDialogStatus = false;
                        return;
                    }
                    this.iptalPenaltyResponse = response.body;
                },
                (response) => {
                    this.iptalLoadingRowKey = null;
                    this.iptalDialogStatus = false;
                    this.HataYonetimi(response, payload, 'Hotel/GetReservationCancelPenalty');
                }
            );
        },

        iptalDialogIptal() {
            this.iptalDialogStatus = false;
            this.iptalSelectedItem = null;
            this.iptalPenaltyResponse = null;
            this.iptalSelectedReason = null;
            this.iptalLoadingRowKey = null;
            this.iptalConfirmLoading = false;
        },

        rezervasyonIptalEt() {
            if (!this.iptalCanConfirmCancel) return;
            const item = this.iptalSelectedItem;
            this.iptalConfirmLoading = true;

            const selectedReasonObj = this.iptalReasonOptions.find(r => r.id === this.iptalSelectedReason);
            const payload = {
                SessionHeader: this.sessionHeader,
                ReservationNumber: item.RezzKod,
                CoperReservationNumber: item.PNR_No,
                Reason: this.iptalSelectedReason,
                ReasonText: selectedReasonObj ? selectedReasonObj.name : '',
                ShoppingCartId: item.ShoppingCardId,
            };

            hotelSearchService.cancelReservation(this.$http, payload).then(
                (response) => {
                    this.iptalConfirmLoading = false;
                    if (response.body.HasError) {
                        this.text1 = (response.body.ServiceError && response.body.ServiceError.Message) || this.$t('Cancel-Reservation-Failed');
                        this.snackbar = true;
                        return;
                    }
                    this.iptalDialogIptal();
                    tool.http_post(this,"RezervasyonIptal",{IptalNo:item.PNR_No,IptalTipi:1,IptalNedeni:selectedReasonObj.name}).then(
                        (response) => {
                            if (response.body.Status == true) {
                                this.text1 = this.$t('Cancel-Reservation-Success');
                                this.snackbar = true;
                                this.getList();
                            } else {
                                this.text1 = response.body.ErrorList[0];
                                this.snackbar = true;
                            }
                        },
                        (response) => {
                            this.HataYonetimi(response, payload, 'RezervasyonIptal');
                        }
                    );
                },
                (response) => {
                    this.iptalConfirmLoading = false;
                    this.HataYonetimi(response, payload, 'Hotel/GetReservationCancel');
                }
            );
        },
    }
};
</script>

<style scoped></style>
